import { Component, Input, Output, EventEmitter, OnInit, OnChanges, OnDestroy } from '@angular/core';
import { ISubheaderRightSection } from '../sub-header.modal';
import { SubheaderHandlerService } from '../../../services/subheader-handler.service';
import { Subscription } from 'rxjs/Subscription';
import { Dropdown, DropdownOption, IDropdownEventType } from '../../multiselect-dropdown/multiselect-dropdown-model';

@Component({
    selector: 'app-subheader-right-section',
    templateUrl: './right-section.component.html'
})
export class SubHeaderRightSectionComponent implements OnInit, OnChanges, OnDestroy {
    @Input() details: ISubheaderRightSection;
    @Input() showOnMobile: boolean;
    @Output() btnClick = new EventEmitter<string>();
    @Output() ddFiltersChange = new EventEmitter<IDropdownEventType>();
    currentPageNameSubscription: Subscription;
    enablePageNameSubscription: Subscription;
    hideSaveProgressSubscription: Subscription;
    rightSectionSourceSubscription: Subscription;
    currentPageName: string;
    showSaveProgress = false;
    enableSaveProgress = false;
    hideSaveProgress = false;
    customerData: Dropdown;
    regionData: Dropdown;
    revenueData: Dropdown;
    statusData: Dropdown;
    showDropdown = false;
    defaultSelectText = 'All';
    revenue: string[] = ['<100K', '100K - 750K ', '750K - 3M', '3M - 10M', '>10M'];
    status: string[] = ['Draft', 'Pending', 'Advocating', 'Won', 'Lost', 'Terminated'];
    filtersObject: any = {
        'customers': [],
        'regions': [],
        'revenues': [],
        'status': []
    };

    constructor(private subHeaderService: SubheaderHandlerService) {
    }

    ngOnInit() {
        this.currentPageNameSubscription = this.subHeaderService.currentPageName$.subscribe(
            (pageNameCaseId) => {
                this.updatePageName(pageNameCaseId);
            });

        this.enablePageNameSubscription = this.subHeaderService.enableSaveProgress$.subscribe(
            (enableSaveProgress) => {
                this.enableSaveProgressForPage(enableSaveProgress);
            });

        this.rightSectionSourceSubscription = this.subHeaderService.subheaderRightSection$.subscribe(
            (filtersData) => {
                this.addFiltersData(filtersData);
            }
        );
    }

    ngOnChanges() {
        this.updateCurrentPage();
    }
    updatePageName(pageNameCaseId: any) {
        this.currentPageName = pageNameCaseId.pageName;
        this.updateCurrentPage();
    }

    private updateCurrentPage() {
        if ((this.currentPageName && this.currentPageName !== 'SiteSelection'
            && this.currentPageName !== 'evaluator' && this.currentPageName !== 'solutionsSummary')
            || (this.details && this.details.currentPageName && this.details.currentPageName !== 'SiteSelection'
                && this.details.currentPageName !== 'evaluator' && this.details.currentPageName !== 'solutionsSummary')) {
            this.showSaveProgress = true;
        } else {
            this.showSaveProgress = false;
        }
        if (this.currentPageName !== 'evaluator') {
            this.showDropdown = false;
        }
    }

    addFiltersData(filtersData) {
        if (this.details && this.details.currentPageName === 'evaluator' && this.details.customers) {
            this.customerData = new Dropdown();
            this.regionData = new Dropdown();
            for (const cst of this.details.customers.customersList) {
                this.customerData.options.push(
                    new DropdownOption({
                        text: cst.customerName,
                        value: cst.id.toString()
                    }));
                for (const region of cst.regionsList) {
                    if (this.regionData.options.length === 0 || this.regionData.options.filter(rg => rg.text === region.regionName &&
                        rg.value === region.id.toString()).length === 0) {
                        this.regionData.options.push(
                            new DropdownOption({
                                text: region.regionName,
                                value: region.id.toString()
                            }));
                    }
                }
            }
            this.showDropdown = true;
            this.addRevenueDropdownData();
            this.addStatusDropdownData();
            this.customerData.name = 'Customers';
            this.customerData.label = 'CUSTOMER';
            this.regionData.name = 'Regions';
            this.regionData.label = 'GLOBAL REGION';
            this.getInitialDataForDashboard();
        } else {
            this.showDropdown = false;
        }
    }

    addRevenueDropdownData() {
        this.revenueData = new Dropdown();
        for (let i = 0; i < this.revenue.length; i++) {
            this.revenueData.options.push(
                new DropdownOption({
                    text: this.revenue[i],
                    value: this.revenue[i]
                }));
        }
        this.revenueData.name = 'Revenue';
        this.revenueData.label = 'Opportunity Value';
    }

    addStatusDropdownData() {
        this.statusData = new Dropdown();
        for (let i = 0; i < this.status.length; i++) {
            this.statusData.options.push(
                new DropdownOption({
                    text: this.status[i],
                    value: this.status[i]
                }));
        }
        this.statusData.name = 'Status';
        this.statusData.label = 'STATUS';
    }

    enableSaveProgressForPage(enableSaveProgress: boolean) {
        this.enableSaveProgress = enableSaveProgress;
    }

    btnClickInSubhead(which: string) {
        this.btnClick.emit(which);
    }

    getInitialDataForDashboard() {
        // Initally All Values will be Selected. Hence, sending null in selection.
        if (this.filtersObject.customers.length >= 0) {
            this.filtersObject.customers = [];
            this.customerData.options.forEach(o => {
                this.filtersObject.customers.push(JSON.parse(JSON.stringify(o.value)));
            });
        }
        if (this.filtersObject.regions.length >= 0) {
            this.filtersObject.regions = [];
            this.regionData.options.forEach(o => {
                this.filtersObject.regions.push(JSON.parse(JSON.stringify(o.value)));
            });
        }
        if (this.filtersObject.revenues.length >= 0) {
            this.filtersObject.revenues = [];
            this.revenueData.options.forEach(o => {
                this.filtersObject.revenues.push(JSON.parse(JSON.stringify(o.value)));
            });
        }
        if (this.filtersObject.status.length >= 0) {
            this.filtersObject.status = [];
            this.statusData.options.forEach(o => {
                this.filtersObject.status.push(JSON.parse(JSON.stringify(o.value)));
            });
        }
        this.subHeaderService.sendFiltersValues(this.filtersObject);
    }

    getSelectedDataForDashboard(event) {
        if (event.ddName === 'Customers') {
            if (event.selectedValues.length === 0) {
                // this.filtersObject.customers = null;
                this.filtersObject.customers = [];
                this.customerData.options.forEach(o => {
                    this.filtersObject.customers.push(JSON.parse(JSON.stringify(o.value)));
                });
            } else {
                this.filtersObject.customers = event.selectedValues;
            }
        }
        if (event.ddName === 'Regions') {
            if (event.selectedValues.length === 0) {
                // this.filtersObject.regions = null;
                this.filtersObject.regions = [];
                this.regionData.options.forEach(o => {
                    this.filtersObject.regions.push(JSON.parse(JSON.stringify(o.value)));
                });
            } else {
                this.filtersObject.regions = event.selectedValues;
            }
        }
        if (event.ddName === 'Revenue') {
            if (event.selectedValues.length === 0) {
                // this.filtersObject.revenues = null;
                this.filtersObject.revenues = [];
                this.revenueData.options.forEach(o => {
                    this.filtersObject.revenues.push(JSON.parse(JSON.stringify(o.value)));
                });
            } else {
                this.filtersObject.revenues = event.selectedValues;
            }
        }
        if (event.ddName === 'Status') {
            if (event.selectedValues.length === 0) {
                // this.filtersObject.status = null;
                this.filtersObject.status = [];
                this.statusData.options.forEach(o => {
                    this.filtersObject.status.push(JSON.parse(JSON.stringify(o.value)));
                });
            } else {
                this.filtersObject.status = event.selectedValues;
            }
        }
        this.subHeaderService.sendFiltersValues(this.filtersObject);
    }

    saveProgress() {
        if (this.details.currentPageName) {
            this.subHeaderService.saveProgress(this.details.currentPageName);
        } else {
            this.subHeaderService.saveProgress(this.currentPageName);
        }
    }

    ngOnDestroy() {
        this.currentPageNameSubscription.unsubscribe();
        this.enablePageNameSubscription.unsubscribe();
        this.hideSaveProgressSubscription.unsubscribe();
        this.rightSectionSourceSubscription.unsubscribe();
    }
}



// WEBPACK FOOTER //
// D:/a/1/s/Fed/src/app/shared/components/sub-header/right-section/right-section.component.ts